'use client';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery.js';

var useReducedMotion = function(options) {
    return useMediaQuery("(prefers-reduced-motion: reduce)", options)[0];
};

export { useReducedMotion };
